import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {useState, useContext} from 'react'
import { CustomerReportContext } from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerTypeReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,
    isCustomerTypeEntityPerformanceChartDataLoading,
    customerTypeEntityPerformanceChartData,
  } = useContext(CustomerReportContext)

  return (
    <>
      <tr>
        <td>{row.customerType}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=shipping&customer_type=${row.customerType}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.totalShipping}</td>
        <td>{row.contributedShippingPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.customerType}
          entityName={`Shipping Report - ${row.customerType}`}
          onEntityPerformanceChartIdChange={onCustomerTypeEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onCustomerTypeEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={
            onCustomerTypeEntityPerformanceChartDateRangeChange
          }
          entityPerformanceChartFilters={customerTypeEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isCustomerTypeEntityPerformanceChartDataLoading}
          entityPerformanceChartData={customerTypeEntityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </>
  )
}

export default CustomerTypeReportRow
